/**
 *
 * DataTable
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import TextField from "basicComponents/AutosaveTextbox/AutosaveTextbox";
import Edit from "images/EditIcon";
import DropDown from "basicComponents/AutosaveDropDown/AutosaveDropDown";
import Delete from "../../images/DeleteIcon";

class DataTableRow extends Component {
  state = {
    isTextField: false,
    shouldRender: this.shouldRender(),
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const shouldRender = this.shouldRender();

    if (shouldRender !== this.state.shouldRender) {
      this.setState({ shouldRender });
    }
  };

  transformLabelToTextField = () => {
    this.setState({
      isTextField: true,
    });
  };

  handleKeyDown = e => {
    if (e.key === "Enter") {
      this.handleConfirm();
    }
  };

  handleConfirm = () => {
    if (this.props.item.value && this.props.item.value.length >= 2) {
      this.props.handleConfirm();
      this.setState({ isTextField: false });
    }
  };

  shouldRender() {
    if (document.body.clientWidth > 600) {
      return true;
    }
    return this.props.item.value;
  }

  render() {
    if (this.state.shouldRender) {
      return (
        <Row key={this.props.item.label}>
          <RowContent>
            <Column smallFirstColumn={this.props.smallFirstColumn}>
              <ColumnContent style={{ fontWeight: "bold" }}>
                {this.props.item.label}
              </ColumnContent>
            </Column>
            {!this.state.isTextField ? (
              <Column>
                <ColumnContent id={this.props.item.id}>
                  {this.props.item.value}
                </ColumnContent>
              </Column>
            ) : (
              <Column
                style={{ paddingRight: "1rem" }}
                dropdown={this.props.item.dropDown}
              >
                {!this.props.item.dropDown ? (
                  <TextField
                    noPadding
                    onKeyDown={this.handleKeyDown}
                    focusTextField={!!this.props.item.value}
                    id={this.props.item.id}
                    value={this.props.item.value}
                    onChange={this.props.item.onChange}
                    error={!!this.props.userFailed}
                    onConfirm={this.handleConfirm}
                    disabled={this.props.disabled}
                  />
                ) : (
                  <DropDown
                    onSearchChange={this.props.onSearchChange}
                    enableSearch={this.props.enableSearch}
                    onConfirm={this.handleConfirm}
                    onChange={this.props.item.onChange}
                    value={this.props.item.value}
                    searchText={this.props.searchText}
                    items={this.props.item.dropDownItems.map(
                      value => value.language,
                    )}
                  />
                )}
              </Column>
            )}

            {!this.props.item.hideDeleteIcon ? (
              <DeleteIcon
                id={`deleteIcon${this.props.item.id}`}
                className="icon"
                deleteIcon={!this.props.item.hideDeleteIcon}
                key={this.props.item.hideDeleteIcon}
                onClick={this.props.onPatientDelete}
              >
                <Delete />
              </DeleteIcon>
            ) : (
              <NoIcon />
            )}

            {!this.props.item.disableIcon ? (
              <EditIcon
                id={`editIcon${this.props.item.id}`}
                className="icon"
                editIcon={!this.props.item.disableIcon}
                key={this.props.item.disableIcon}
                onClick={this.transformLabelToTextField}
              >
                <Edit />
              </EditIcon>
            ) : (
              <NoIcon />
            )}
          </RowContent>
        </Row>
      );
    }
    return null;
  }
}

DataTableRow.propTypes = {
  item: PropTypes.object,
  handleConfirm: PropTypes.func,
  userFailed: PropTypes.bool,
  disabled: PropTypes.bool,
  smallFirstColumn: PropTypes.bool,
  enableSearch: PropTypes.bool,
  onSearchChange: PropTypes.func,
  searchText: PropTypes.string,
  onPatientDelete: PropTypes.func,
};

DataTableRow.defaultProps = {};

const NoIcon = styled.div`
  width: 50px;
  height: 24px;
`;

const DeleteIcon = styled.div`
  ${({ deleteIcon }) =>
    !deleteIcon ? "display:none" : "display:inline-block"};
`;

const EditIcon = styled.div`
  ${({ editIcon }) => (!editIcon ? "display: none" : "display: inline-block")};
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  padding-top: 5px;

  &:not(:first-child) {
    padding-top: 10px;
  }

  &:not(:last-child) {
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }

  ${({ theme }) => theme.phone`
    &:last-child {
        padding-bottom: 10px;
        border-bottom: 1px solid #eeee;
    }
  `};
`;
const RowContent = styled.div`
  display: flex;
  width: 100%;
`;

const Column = styled.div`
  display: flex;
  width: 100%;

  text-overflow: ellipsis;

  ${({ dropdown }) => !dropdown && "overflow: hidden;"};

  ${({ theme }) => theme.tabletPortraitUp`
        ${({ dropdown }) => !dropdown && "overflow: inherit;"};
  `};

  white-space: nowrap;

  &:first-child {
    //width: 232px;
    width: 100%;
  }
`;
const ColumnContent = styled.div`
  display: flex;
  width: 100%;
  white-space: nowrap;
  padding-right: ${({ theme }) => theme.padding}rem;
      width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
/* 
  ${({ theme }) => theme.phone`
        width: 160px;
    `}; */
`;

export default DataTableRow;
